import { useEffect,useRef } from "react";

function  useInterval (callback: any,delay: any) : void {
    const savedCallBack: any = useRef();

    useEffect(() => {
        savedCallBack.current = callback
    },[callback]);

    useEffect(() => {
    if(delay !== null) {
        const id = setInterval(() => savedCallBack.current(),delay);
        return () => {
            clearInterval(id);
        }
    }
    },[delay]);
}

export default useInterval;